//nasconde l'immagine sotto alle collezioni se è vuota
  document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector("#shopify-section-template--24463275393356__image_with_text_overlay_hFNpNt");
    const placeholder = section.querySelector("svg.placeholder_svg_tag");

    if (placeholder) {
      section.style.display = "none";
    }
  });

//nasconde sezioni vuote senza campi rich text

  document.addEventListener("DOMContentLoaded", function () {
    const sectionsToCheck = [
      "#shopify-section-template--24463275393356__rich_text_DJ8LNA",
      "#shopify-section-template--24463275393356__rich_text_iwFct4",
      "#shopify-section-template--24463276343628__rich_text_rcAhCX",
      "#shopify-section-template--24463276343628__rich_text_kA4FQr",
      "#shopify-section-template--24463276343628__rich_text_DxjhkT",
      "#shopify-section-template--24463276343628__rich_text_p8iQ34"
    ];

    sectionsToCheck.forEach(selector => {
      const section = document.querySelector(selector);
      if (!section) return;

      const inner = section.querySelector(".rich-text__inner");
      if (!inner) return;

      const content = inner.innerText.trim();
      const hasUsefulContent = content.length > 0;

      const visibleLinks = inner.querySelectorAll("a[href]");
      const hasLinks = Array.from(visibleLinks).some(link => link.innerText.trim().length > 0);

      if (!hasUsefulContent && !hasLinks) {
        section.style.display = "none";
      }
    });
  });


